module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('ul', [(_vm.testimonial) ? _c('testimonial', {
    attrs: {
      "test": _vm.testimonial
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.ps), function(p) {
    return _c('li', {
      key: p.id,
      staticClass: "widget"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('h5', [_vm._v(_vm._s(p.name))])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('ul', [_c('li', [_vm._v(_vm._s(p.name))]), _vm._v(" "), (p.current_price !== p.previous_price) ? _c('li', [_c('strike', [_vm._v("$" + _vm._s(p.previous_price))])], 1) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("$" + _vm._s(p.current_price))]), _vm._v(" "), _c('li', {
      staticStyle: {
        "margin-left": "-8px",
        "padding-top": "10px"
      }
    }, [_c('purchase-button', {
      attrs: {
        "package": p
      }
    })], 1)])])])
  }), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "7997332272",
      "ad-style": "display:inline-block;width:250px;height:250px",
      "ad-format": "auto"
    }
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-24e98352!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar.vue
// module id = 488
// module chunks = 1